import { FinancePartnerDetails } from "../@types/types";
import bearerAxios from "../helpers/bearerAxios";
import {logger} from "./loggingService";


const getACADExcelFile = async (opId: string, designId: string, financePartnerDetails: FinancePartnerDetails | null) => {
    const { name, purchaseMethod } = financePartnerDetails || {};
    const payLoad = {
        opportunityId: opId,
        designId: Number(designId),
        financePartner: name ?? 'Good Leap',
        purchaseMethod: purchaseMethod ?? '',
    };
    try {
        return bearerAxios
            .post(import.meta.env.VITE_BASE_URL + import.meta.env.VITE_GET_ACAD_FILE!, payLoad, {
                responseType: 'blob'
            })
            .then((response) => {
                return response.data;
            });
    } catch (error) {
        logger.error(error);
        throw error;
    }
};


export {getACADExcelFile};